import React, { useState, useEffect } from 'react';
import { Card, Table, Button, Badge } from 'react-bootstrap';
import { FaCheckCircle, FaTimesCircle, FaUserClock } from 'react-icons/fa';
import { toast } from 'react-toastify';
import Header from '../../../components/common/Header';
import StudentService from '../../../services/studentService';

const VerificationRequests = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadRequests();
  }, []);

  const loadRequests = async () => {
    try {
      setLoading(true);
      const response = await StudentService.getPendingRequests();
      setRequests(response.data || []);
    } catch (error) {
      toast.error('Failed to load verification requests');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleVerification = async (userId, status) => {
    try {
      await StudentService.verifyStudent(userId, status);
      toast.success(`Student ${status} successfully`);
      loadRequests(); // Reload the list
    } catch (error) {
      toast.error(`Failed to ${status} student`);
    }
  };

  return (
    <div>
      <Header />
      <div className="container-fluid p-4">
        <h2 className="mb-4">
          <FaUserClock className="me-2 text-warning" />
          Pending Verification Requests
        </h2>

        <Card>
          <Card.Body>
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <Table striped bordered hover responsive>
                <thead className="bg-light">
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Registered On</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {requests.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="text-center py-4">
                        No pending verification requests
                      </td>
                    </tr>
                  ) : (
                    requests.map((request, index) => (
                      <tr key={request.id}>
                        <td>{index + 1}</td>
                        <td>
                          <strong>{request.name}</strong>
                        </td>
                        <td>{request.email}</td>
                        <td>{request.phone}</td>
                        <td>{new Date(request.created_at).toLocaleDateString()}</td>
                        <td>
                          <Button
                            variant="success"
                            size="sm"
                            className="me-2"
                            onClick={() => handleVerification(request.id, 'approved')}
                          >
                            <FaCheckCircle className="me-1" /> Approve
                          </Button>
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => handleVerification(request.id, 'rejected')}
                          >
                            <FaTimesCircle className="me-1" /> Reject
                          </Button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            )}
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default VerificationRequests;